function normalizeCode(value) {
  return String(value || "").trim().toUpperCase();
}

const CODE_MESSAGES = {
  PROCUREMENT_APPROVAL_MANDATE_DENIED: "Geen mandaat om dit bedrag goed te keuren.",
  PROCUREMENT_APPROVAL_PERMISSION_DENIED: "Je hebt geen toestemming om inkooporders goed te keuren.",
  PROCUREMENT_ORDER_PERMISSION_DENIED: "Je hebt geen toestemming om externe bestelling te bevestigen.",
  PROCUREMENT_EXTERNAL_ORDER_PROOF_REQUIRED: "Extern bestelbewijs is verplicht om als besteld te markeren.",
  PROCUREMENT_MANUAL_ORDER_NOTE_REQUIRED: "Notitie is verplicht bij handmatige bestelbevestiging.",
  PROCUREMENT_STATUS_TRANSITION_FORBIDDEN: "Deze statusovergang is niet toegestaan.",
  PROCUREMENT_BOUNDARY_STATUS_PATCH_BLOCKED:
    "Gebruik de specifieke goedkeur- of bestelactie voor deze status.",
  PROCUREMENT_STATUS_UNSUPPORTED: "Deze status wordt niet ondersteund.",
  PROCUREMENT_REQUEST_DENIED: "Dit bestelverzoek valt buiten de ingestelde policy.",
  PROCUREMENT_ORDER_NOT_FOUND: "Inkooporder niet gevonden.",
  PROCUREMENT_ORDER_ID_INVALID: "Ongeldige order id.",
};

export default function procurementErrorMessage(err, fallbackMessage = "Inkoopactie mislukt.") {
  const code = normalizeCode(err?.response?.data?.code || err?.code);
  const backendMessage = String(err?.response?.data?.message || "").trim();
  if (backendMessage) return backendMessage;
  if (code && CODE_MESSAGES[code]) return CODE_MESSAGES[code];

  const status = Number(err?.response?.status || 0);
  if (!status) return "Verbinding met de server mislukt. Probeer opnieuw.";
  if (status === 403) return "Je hebt geen rechten om deze inkoopactie uit te voeren.";
  if (status === 404) return "De inkooporder bestaat niet (meer).";
  if (status === 409) return "Deze inkoopactie past niet bij de huidige orderstatus.";
  if (status >= 500) return "Serverfout tijdens inkoopactie. Probeer opnieuw.";

  return fallbackMessage;
}
